import styled from 'styled-components'

import MarkdownText from '../../MarkdownText'
import breakpoints from '../../../theme/breakpoints'
import Link from '../../Link'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Column = styled.div`
  ${breakpoints.up('tablet')} {
    max-width: 20rem;
    &:first-child {
      margin-right: 2.4rem;
    }
  }
`

export const Title = styled.h5`
  ${(props) => props.theme.textStyles.text};
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.pureWhite};
  margin-bottom: 1.6rem;
  ${breakpoints.up('tablet')} {
    font-size: 1.4rem;
  }
`

export const ContactUsCta = styled(Link)`
  color: ${(props) => props.theme.colors.pureWhite};
  ${(props) => props.theme.textStyles.textLargeStrong};
  font-weight: bold;
`

export const Markdown = styled(MarkdownText)<{ $isSmall?: boolean }>`
  ${(props) => props.theme.textStyles.text};
  font-size: ${(props) => (props.$isSmall ? '1rem' : '1.2rem')};
  margin-bottom: 1.6rem;
  color: ${(props) => props.theme.colors.pureWhite};

  & a {
    color: ${(props) => props.theme.colors.pureWhite};
    text-decoration: none;
  }

  & strong {
    font-weight: 700;
  }
`
